import React, { useState } from "react";
import {
  DndContext,
  closestCorners,
  PointerSensor,
  TouchSensor,
  KeyboardSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { arrayMove, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Input from "../../components/Input/input";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Column } from "../../components/Column/columns";
import "./AnrMachine.css";
import { getToken, base_url } from "../../config/config";

function AnrMachine() {
  const { number } = useParams();
  const [tasks, setTasks] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const updatedTasks = useSelector((state) => state); // Assuming 'tasks' is the slice of state containing tasks

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const addTask = (data) => {
    setTasks((tasks) => [
      ...tasks,
      { id: tasks.length + 1, title: data.title, color: data.color },
    ]);
  };

  const deleteTask = (taskId) => {
    setTasks((tasks) => tasks.filter((task) => task.id !== taskId));
  };

  const getTaskPos = (id) => tasks.findIndex((task) => task.id === id);

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over) return; // If not dropped on a valid target

    if (active.id === over.id) return;

    setTasks((tasks) => {
      const originalPos = getTaskPos(active.id);
      const newPos = getTaskPos(over.id);
      return arrayMove(tasks, originalPos, newPos);
    });
  };

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(TouchSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  );

  const SubmitAnr = () => {
    // Your data

    console.log({
      number: number,
      process: updatedTasks.processes,
      date: selectedDate,
    });

    // Convert selectedDate to DD/MM/YYYY format
    const parsedDate = new Date(selectedDate);
    const formattedDate = `${parsedDate.getDate()}-${
      parsedDate.getMonth() + 1
    }-${parsedDate.getFullYear()}`;

    // Data to send to the server
    const data = {
      number: number,
      process: updatedTasks.processes,
      date: formattedDate, // Use the formatted date
    };

    // POST request to submit the data
    fetch(`${base_url}/v1/createAnrCalendar`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        console.log("Anr created successfully:", data);
        // Perform any further actions you need with the response data
      })
      .catch((error) => {
        console.error("There was a problem creating the Anr:", error);
        // Handle error
      });
  };

  return (
    <div style={{ textAlign: "center" }}>
      <h1>Process for ANR: {number}</h1>
      <label>Start Date:</label>
      <DatePicker
        selected={selectedDate}
        onChange={handleDateChange}
        dateFormat='dd/MM/yyyy'
      />

      <div className='App'>
        <DndContext
          sensors={sensors}
          collisionDetection={closestCorners}
          onDragEnd={handleDragEnd}>
          <Column tasks={tasks} onDelete={deleteTask} />
          <Input onSubmit={addTask} />
        </DndContext>
      </div>
      <div>
        <button onClick={SubmitAnr}>SUBMIT</button>
      </div>
    </div>
  );
}

export default AnrMachine;